<!-- 资源建设类型分布 -->
<template>
    <div class="resource-construction-types-chart">
        <div class="resource-construction-types-chart-title">
            <div class="name">资源建设类型分布</div>
        </div>
        <div class="chart" id="resourceConstructionTypesChartId" v-show="isShow"></div>
        <div class="chart-error" v-show="!isShow">
            <div class="detail">
                <span class="detail">暂无数据!</span>
            </div>
        </div>
    </div>
</template>
<script>

import { getPlatformResourceTypeStatAPI, getPlatformResourceStatAPI } from "@/service/api.js"
export default {
    name: 'resource-construction-types-chart',
    components: {
    },
    props: {
        regionId: {
            type: String,
            default: ''
        },
        regionType: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        },
        //学校id
        schoolId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            resourceList: [],
            isShow: "true",
            //总的资源数
            rescourcecount: ""
        }
    },
    watch: {
        startTime() {
            this.getPlatformResourceStat();
        },
        endTime() {
            this.getPlatformResourceStat();
        },
        schoolId() {
            this.getPlatformResourceStat();
        },
        address() {
            this.getPlatformResourceStat();
        }
    },
    methods: {
        /**
         * @name 初始化echarts图表
         */
        initEchart() {
            let _this = this;
            let nameList = _this.resourceList.map((item) => {
                return item.resourceName

            })
            let numberList = _this.resourceList.map((item) => {
                return item.resourceNumber
            })
            let dataSource = _this.$echarts.init(
                document.getElementById('resourceConstructionTypesChartId')
            );
            const option = {
                grid: {
                    left: '15%',
                    top: '10%',
                },
                xAxis: {
                    axisTick: false,
                    type: 'category',
                    data: nameList,
                    axisLabel: {
                        interval: 0,
                        color: '#708ACC',
                        formatter: function (value) {
                            if (value) {
                                if (value.length > 4) {
                                    let nameList = [];
                                    for (var i = 0; i < value.length; i += 4) {
                                        nameList.push(value.substring(i, i + 4));
                                    }
                                    return nameList.join("\n")
                                } else {
                                    return value
                                }
                            }
                        }
                    },
                    axisLine: {
                        show: true,//是否显示轴线
                        lineStyle: {
                            color: '#6076AD',//刻度线的颜色
                            width: 2
                        }
                    },
                },
                yAxis: {
                    type: 'value',
                    axisTick: false,
                    axisLine: false,
                    splitLine: {
                        lineStyle: {
                            color: '#233162'
                        }
                    },
                    axisLabel: {
                        color: '#708ACC',
                    },
                },
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#67E0E3' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#0181DE' // 100% 处的颜色
                    }],
                    global: false
                },
                series: [
                    {
                        data: numberList,
                        barWidth: 18,
                        type: 'bar',
                        itemStyle: {
                            barBorderRadius: [4, 4, 0, 0]
                        },
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}',
                            fontSize: 12,
                            color: '#0EFCFF'
                        }
                    }
                ]
            }
            dataSource.setOption(option);
            window.addEventListener("resize", function () {
                dataSource.resize();
            });
        },
        /**
         * @name 获取平台资源统计
         */
        getPlatformResourceStat() {
            let params = {
                regionId: this.regionId,
                provinceId: this.provinceId,
                cityId: this.cityId,
                districtId: this.districtId,
                address: this.address,
                startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                regionType: this.regionType,
                schoolId: this.schoolId,
            }
            getPlatformResourceStatAPI(params).then((res) => {
                this.rescourcecount = res.rsNum
                this.getPlatformResourceTypeStat()
            }).catch((err) => { })
        },

        /**
         * @name 获取平台资源类型统计指标
        */
        getPlatformResourceTypeStat() {
            this.resourceList = [];
            let params = {
                regionId: this.regionId,
                startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                schoolId: this.schoolId,
                provinceId: this.provinceId,
                cityId: this.cityId,
                districtId: this.districtId,
                address: this.address,
                regionType: this.regionType
            }
            //rcount:当前资源总数；iscount：不包含其他类别的资源数；isother：接口返回的是否包含其他类型的资源（0：不包含；1：包含）
            let [rcount, iscount, isother] = [0, 0, 0];
            getPlatformResourceTypeStatAPI(params).then((res) => {
                this.resourceList = res.map((item) => {
                    rcount += item.rsNum;
                    iscount = item.typeCode != '313other' ? iscount + item.rsNum : iscount
                    isother = item.typeCode == '313other' ? 1 : 0;
                    return {
                        resourceName: item.typeName,
                        resourceCode: item.typeCode,
                        resourceNumber: item.rsNum,
                    }
                })
                if (this.rescourcecount != rcount & isother === 1) {
                    this.resourceList.map((item) => {
                        item.resourceNumber = item.resourceCode == '313other' ? (this.rescourcecount - iscount) :  item.resourceNumber
                    })
                } else if (this.rescourcecount != rcount && isother == 0) {
                    this.resourceList.push({
                        resourceName: "其他",
                        resourceCode: "313other",
                        resourceNumber: (this.rescourcecount - iscount)
                    })
                }
                this.resourceList.sort((a, b) => {
                    return b.resourceNumber - a.resourceNumber;

                })
                this.isShow = this.resourceList.length == 0 ? false : true;
                //初始化图表
                this.initEchart();
            }).catch((err) => { })
        },
    },
    mounted() {
        //  获取平台资源类型统计指标
        this.getPlatformResourceStat();
    }
}
</script>
<style lang="scss" scoped>
.resource-construction-types-chart {
    width: 100%;
    height: 320px;
    margin-top: 25px;
    background: rgba(9, 19, 66, 0.94);
    border-radius: 0px 0px 4px 4px;

    .resource-construction-types-chart-title {
        background: url("~@/assets/images/qingxudataboard/title-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    .chart {
        width: 100%;
        height: 300px;
    }

    .chart-error {
        width: 100%;
        height: 260px;
        display: flex;
        align-items: center;
        justify-content: center;

        .detail {
            font-size: 16px;
            color: #fff;
        }
    }
}
</style>